import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import moment from "moment";

import { setA11yContent } from "../../NavigationHelper/actions";
import { checkNestedObject } from "utils/checkNestedObject";
import { cleanDateFormat } from "utils/cleanDateFormat";
import { formatPhoneNumber } from "utils/formatPhoneNumber";
import { setBreadcrumbList } from "common-components/BreadCrumbs/actions";
import { agentCancelDownload } from "../actions";

import Alert from "common-components/Alert";
import RectangleLoader from "common-components/RectangleLoader";
import { DownloadPending } from "./DownloadPending";
import { DownloadReady } from "./DownloadReady";

import FetchPageContent from "../../../../hoc/FetchPageContent";

class CustomerDownloadStatus extends Component {
  state = {
    showCancelModal: false,
    showDownloadModal: false,
    hasGoneThroughMFA: false
  };

  componentDidMount() {
    if (checkNestedObject(this.props.breadCrumbs, "landingPage")) {
      const { landingPage, downloadFile, requestStatus } = this.props.breadCrumbs;
      this.props.setBreadcrumbList([
        { label: landingPage, path: "/privacy/secure/authorized-agent" },
        {
          label: this.props.agentSelectedCustomerDownload.downloadReady ? downloadFile : requestStatus,
          path: "/privacy/secure/authorized-agent/customer/status"
        }
      ]);
    }

    if (checkNestedObject(this.props.pageContent, "sc_pagetitle")) {
      this.props.setA11yContent(
        this.props.agentSelectedCustomerDownload.downloadReady ? "download ready" : "download status",
        this.props.pageContent.sc_pagetitle
      );
    }

    if (checkNestedObject(this.props.location, "state", "showDownloadModal")) {
      this.setState({ showDownloadModal: true, hasGoneThroughMFA: true });
    }
  }

  toggleModal = type => {
    if (type === "cancel") {
      this.setState({ showCancelModal: !this.state.showCancelModal });
    } else {
      this.setState({ showDownloadModal: !this.state.showDownloadModal });
    }
  };

  handleCancelClick = () => {
    this.toggleModal("cancel");
    this.props.agentCancelDownload().then(() => {
      if (!this.props.error) {
        this.props.history.push("/privacy/secure/authorized-agent/customer", "cancelSuccess");
      }
    });
  };

  handleDownloadReadyClick = () => {
    if (this.state.hasGoneThroughMFA) {
      return this.toggleModal();
    }
    const {uniqueTxnId} = this.props.agentSelectedCustomerDownload;
    return this.props.history.push("/privacy/secure/authorized-agent/multifactor-authentication-primer", {
      confirmAuth: true,
      nextRoute: "/privacy/secure/authorized-agent/customer/download-password",
      showDownloadModal: false,
      resendPWFlow: true,
      requesPassword: true,
      uniqueTxnId:uniqueTxnId
    });
  };
  renderCategoryList = () => {
    if (this.props.agentSelectedCustomerDownload && this.props.agentSelectedCustomerDownload.requestCategories) {
      return (
        <ul style={{margin: '10px 0 0 16px',listStyleType: 'disc'}}>
          {this.props.agentSelectedCustomerDownload.requestCategories.map(item => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      );
    }
    return null;
  };

  checkForCSRFTokenInfo = () => {
    const el = document.querySelector('meta[name="csrfToken"]');

    if (el && el.getAttribute("content")) {
      return el.getAttribute("content");
    }
    return "";
  };

  render() {
    if (this.props.loading) {
      return <RectangleLoader />;
    }
    const commonProps = {
      requestCategories: this.renderCategoryList,
    };
    const {
      downloadReady,
      dateOfRequest,
      downloadAvailabilityDeadline,
      fileFormat,
      fileSize,
      uniqueTxnId
    } = this.props.agentSelectedCustomerDownload;

    
    return (
      <Fragment>
        {this.props.error ? <Alert alertType="error">{this.props.error}</Alert> : null}

        {downloadReady ? (
          <DownloadReady
            {...commonProps}
            pageContent={this.props.download_complete}
            handleClick={this.handleDownloadReadyClick}
            dateOfRequest={moment(cleanDateFormat(dateOfRequest)).format("MMM DD, YYYY")}
            selectedMDN={formatPhoneNumber(this.props.customerMdn)}
            downloadAvailabilityDeadline={moment(downloadAvailabilityDeadline).format("MMM DD, YYYY")}
            dateRange={this.props.downloadAmount.label}
            showModal={this.state.showDownloadModal}
            modalContent={this.props.downloadFileModalContent}
            checkForCSRFTokenInfo={this.checkForCSRFTokenInfo}
            toggleModal={this.toggleModal}
            mtn={this.props.customerMdn}
            fileFormat={fileFormat}
            fileSize={fileSize}
            uniqueTxnId={uniqueTxnId}
          />
        ) : (
          <DownloadPending
            pageContent={this.props.download_pending}
            dateOfRequest={moment(cleanDateFormat(dateOfRequest)).format("MMM DD, YYYY")}
            modalContent={this.props.cancelDownloadModalContent}
            toggleModal={() => this.toggleModal("cancel")}
            handleCancelClick={this.handleCancelClick}
            showModal={this.state.showCancelModal}
            notificationMethod={window.reactGlobals.agentInfo.agentEmailId}
          />
        )}
      </Fragment>
    );
  }
}

const mapStateToProps = ({
  pageContent: {
    download_pending,
    download_complete,
    download_review: cancelDownloadModalContent,
    download_file: downloadFileModalContent,
    breadCrumbs
  },
  agentSelectedCustomer: { mtn: customerMdn },
  loadingAndErrorState: { loading, error },
  agentSelectedCustomerDownload,
  downloadAmount
}) => ({
  download_pending,
  download_complete,
  cancelDownloadModalContent,
  downloadFileModalContent,
  agentSelectedCustomerDownload,
  customerMdn,
  loading,
  error,
  breadCrumbs,
  downloadAmount
});

export default compose(
  connect(
    mapStateToProps,
    { setA11yContent, setBreadcrumbList, agentCancelDownload }
  ),
  FetchPageContent
)(CustomerDownloadStatus);
